import styled from 'styled-components';
import { getSize, SizeTypes } from '../utils/getSize';
import { fontFamily, media, mutedForeground, textColorDark, textSize } from '../utils/variables';

interface TextProps {
    extent?: SizeTypes | string;
    color?: string;
    weight?: string | number;
}

export const Text = styled.span<TextProps>`
    @media print {
        display: block;
        border: none;
        box-shadow: none;
        page-break-after: always;
        page-break-before: always;
        margin: 0;
    }
    
    font-size: ${({ extent }) => extent
        ? `${getSize(extent, textSize)}`
        : 'unset'
    };
    font-weight: ${({ weight }) => weight
        ? weight
        : 'unset'
    };
    color: ${({ color }) => color
        ? color
        : 'unset'
    };
  ${media.mobile} {
    font-size: ${({ extent }) => extent
            ? `${getSize(extent, textSize)}`
            : '14px'
    };
  };
`;

export const TransactionInputText = styled(Text)`
    color: ${textColorDark};
    font-size: 14px;
    font-weight: 500;
    font-family: ${fontFamily};
`;

export const TransactionMutedText = styled(TransactionInputText)`
    color: ${mutedForeground};
`;